module.exports = __webpack_public_path__ + "057be015266624fb07bfce7c4965a25b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bm.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bm.svg
// module chunks = 0